const namespaced = true

const state = {
  tariffs: {}
}

const mutations = {
  setOverrideTariffSettings (state, data) {
    state.tariffs = data
  }
}

const getters = {
  getOverrideTariffSettings: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideTariffSettings.js